import { Container, Flex, Grid, GridItem } from "@chakra-ui/react";
import { Outlet, useLocation } from "react-router-dom";

import { useUserSelector, useAppConfigSelector } from "@context/hooks";
import { useStudentData } from "@/context";
import Footer from "@components/Footer";
import Header from "@components/Header";
import HelpButton from "@components/HelpButton";
import { PageLoader } from "@euka-mfes/bark";
import { getHomeRoute } from "@utils/route";
import { REQUEST_STATUS } from "@ts/enums/RequestStatus";

const HEADER_HEIGHT_VAR = "var(--euka-header-height, 96px)";

const LearningLayout = () => {
  const { isAppLoading } = useAppConfigSelector();
  const { termsStatus, weekLessonsStatus } = useStudentData();
  const { selectedGrade } = useUserSelector();
  const { pathname } = useLocation();

  // Combine loading states from context
  const isContextLoading =
    termsStatus === REQUEST_STATUS.PENDING ||
    weekLessonsStatus === REQUEST_STATUS.PENDING;
  const isLoading = isAppLoading || isContextLoading;

  const homePath = getHomeRoute(selectedGrade?.grade_code as number);
  const isDashboard = pathname === homePath;
  const isOrientation = pathname.includes("/orientation");

  return (
    <Flex
      flexDir="column"
      w="full"
      minH="100vh"
      justifyContent="space-between"
      bg="gradeTheme.pageBg"
      position="relative"
    >
      <Header isOrientation={isOrientation} />

      <Container
        maxW="1140px"
        flexGrow="1"
        pt={HEADER_HEIGHT_VAR}
        px={isOrientation ? 0 : undefined}
        display="flex"
        flexDir="column"
      >
        <Outlet />
      </Container>

      {isLoading && (
        <PageLoader overlayColor="gradeTheme.pageBg" top={HEADER_HEIGHT_VAR} />
      )}

      {!isOrientation &&
        (isDashboard ? (
          <Container maxW="1140px">
            <Grid
              templateColumns={{
                base: "1fr",
                lg: "repeat(12, minmax(0, 1fr))"
              }}
            >
              <GridItem 
                colSpan={{ base: 1, lg: 8 }}
                css={{
                  "@media screen and (min-width: 1024px) and (max-width: 1199px)": {
                    gridColumn: "span 7"
                  },
                  "@media screen and (min-width: 1200px)": {
                    gridColumn: "span 8"
                  }
                }}
              >
                <Footer />
              </GridItem>
            </Grid>
          </Container>
        ) : (
          <Container maxW="1140px">
            <Footer />
          </Container>
        ))}

      <HelpButton />
    </Flex>
  );
};

export default LearningLayout;
